// Explicit public namespace. Never derive an account ID from a demo URL.
export const PUBLIC_DEMO_IDS = Object.freeze(["mara", "eli", "ines", "noah"]);
